// extracted by mini-css-extract-plugin
export default {"chart_icon":"ClassworkPerformanceViewResults_chart_icon__KlSrk"};